import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'subscriber_UPDATE',
    smsDelete : 'subscriber_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        count: {},
        countLoading: false,
        countError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_COUNT(state, count) {
            state.count = count;
        },

        COUNT_LOADING (state, loading) {
            state.countLoading = loading;
        },

        COUNT_ERROR (state, hasError) {
            state.countError = hasError;
        }
    },

    actions: {
        async fetchDashboardCount ({ commit }) {
            commit('COUNT_LOADING', true);
            commit('COUNT_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.get_dashboard_count, config);
                let response = result.data.data
                commit('SET_COUNT', response);
                return result
            } catch(error) {
                commit('COUNT_ERROR', true);
            } finally {
                commit('COUNT_LOADING', false);
            }
        }
    },

    getters: {}
}
